import { User, Message, Conversation, Notification } from '@/types/chat';

export const mockUsers: User[] = [
  {
    id: 'c1',
    name: 'Sarah & Mike Thompson',
    email: 'sarah@example.com',
    role: 'client',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah'
  },
  {
    id: 'c2',
    name: 'Emily & James Wilson',
    email: 'emily@example.com',
    role: 'client',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emily'
  },
  {
    id: 'c3',
    name: 'Jessica & David Brown',
    email: 'jessica@example.com',
    role: 'client',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Jessica'
  },
  {
    id: 'c4',
    name: 'Amanda & Chris Garcia',
    email: 'amanda@example.com',
    role: 'client',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Amanda'
  },
  {
    id: 'c5',
    name: 'Rachel & Tom Martinez',
    email: 'rachel@example.com',
    role: 'client',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rachel'
  },
  {
    id: 'talent-1',
    name: 'Emma Photography',
    email: 'emma@example.com',
    role: 'talent',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma'
  },
  {
    id: 'admin-1',
    name: 'Admin User',
    email: 'admin@example.com',
    role: 'admin',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin'
  },
  {
    id: 'billing-1',
    name: 'Sarah Martinez (Billing)',
    email: 'sarah.m@example.com',
    role: 'billing',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Billing'
  },
  {
    id: 'sales-1',
    name: 'Jessica Taylor (Sales)',
    email: 'jessica.t@example.com',
    role: 'sales',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sales'
  },
  {
    id: 'editing-1',
    name: 'David Rodriguez (Editing)',
    email: 'david.r@example.com',
    role: 'editing',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Editing'
  }
];

export interface TeamMember {
  id: string;
  name: string;
  email: string;
  role: 'Admin' | 'Billing' | 'Talent Coordinator' | 'Sales' | 'Editing';
  dateAdded: Date;
  status: 'Active' | 'Pending Invitation';
}

export const mockTeamMembers: TeamMember[] = [
  {
    id: 'team-1',
    name: 'Admin User',
    email: 'admin@example.com',
    role: 'Admin',
    dateAdded: new Date('2023-01-15'),
    status: 'Active'
  },
  {
    id: 'team-2',
    name: 'Sarah Martinez',
    email: 'sarah.m@example.com',
    role: 'Billing',
    dateAdded: new Date('2023-03-20'),
    status: 'Active'
  },
  {
    id: 'team-3',
    name: 'Michael Chen',
    email: 'michael.c@example.com',
    role: 'Talent Coordinator',
    dateAdded: new Date('2023-05-10'),
    status: 'Active'
  },
  {
    id: 'team-4',
    name: 'Jessica Taylor',
    email: 'jessica.t@example.com',
    role: 'Sales',
    dateAdded: new Date('2023-07-01'),
    status: 'Active'
  },
  {
    id: 'team-5',
    name: 'David Rodriguez',
    email: 'david.r@example.com',
    role: 'Editing',
    dateAdded: new Date('2023-08-15'),
    status: 'Active'
  },
  {
    id: 'team-6',
    name: 'Emily Watson',
    email: 'emily.w@example.com',
    role: 'Talent Coordinator',
    dateAdded: new Date('2024-01-10'),
    status: 'Pending Invitation'
  }
];

export const mockConversations: Conversation[] = [
  {
    id: 'conv-1',
    clientId: 'c1',
    talentId: 'talent-1',
    weddingDate: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000), // 45 days from now
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
    lastMessageAt: new Date(Date.now() - 2 * 60 * 60 * 1000)
  }
];

export const mockMessages: Message[] = [
  {
    id: 'msg-1',
    conversationId: 'conv-1',
    senderId: 'c1',
    content: 'Hi! I wanted to discuss the timeline for our wedding photography.',
    type: 'text',
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000),
    read: true
  },
  {
    id: 'msg-2',
    conversationId: 'conv-1',
    senderId: 'talent-1',
    content: 'Hello Sarah! I\'d be happy to discuss. What time works best for you?',
    type: 'text',
    timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000),
    read: true
  },
  {
    id: 'msg-3',
    conversationId: 'conv-1',
    senderId: 'c1',
    content: 'Here\'s our venue layout for reference.',
    type: 'image',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
    attachmentUrl: `${window.location.origin}/images/venue-sample.jpg`,
    attachmentName: 'venue-layout.jpg',
    read: false
  }
];

export const mockNotifications: Notification[] = [
  {
    id: 'notif-1',
    userId: 'talent-1',
    message: 'New message from Sarah Johnson',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
    read: false,
    conversationId: 'conv-1'
  }
];

// Admin Dashboard Mock Data
export interface TalentProfile {
  id: string;
  name: string;
  email: string;
  phone: string;
  onboardingDate: Date;
  currentRate: number;
  status: 'Good Standing' | 'Blacklisted';
  isLoveAndPhotosChoice: boolean;
  role: 'Photographer' | 'Videographer' | 'Both';
  activeBookings: string[];
  pastBookings: string[];
}

export interface ContactLog {
  id: string;
  timestamp: Date;
  method: 'email' | 'phone' | 'text' | 'portal';
  notes: string;
  recordedBy: string;
}

export interface TalentBookingAssignment {
  id: string;
  talentId: string;
  bookingId: string;
  clientName: string;
  eventCity: string;
  eventState: string;
  eventDate: Date;
  rate: number;
  status: 'Talent Confirmed' | 'Talent Reached Out to Client' | 'Media Uploaded' | 'Talent Paid' | 'Job Completed';
  notes: { id: string; text: string; author: string; date: Date }[];
  firstContactTimestamp?: Date;
  firstContactMethod?: 'email' | 'phone' | 'text' | 'portal';
  contactStatus: 'pending' | 'completed';
  contactDeadline: Date;
  contactLogs: ContactLog[];
}

export interface Announcement {
  id: string;
  message: string;
  createdAt: Date;
  expiresAt: Date | null;
  createdBy: string;
  targetZipCode?: string | null;
  radiusMiles?: number | null;
}

export interface FlaggedAccount {
  id: string;
  accountName: string;
  accountType: 'Client' | 'Talent';
  reason: string;
  severity: 'medium' | 'high';
  dateFlagged: Date;
  status: 'Open' | 'Resolved';
  notes: string;
  flaggedBy: string;
  assignedTo?: string;
  entity?: string;
}

export interface ZipCodeAnalytics {
  zipCode: string;
  city: string;
  state: string;
  searchCount: number;
  percentage: number;
}

export interface StateBookings {
  state: string;
  bookingCount: number;
}

export interface OperationalData {
  date: Date;
  messagesSent: number;
  labelAssignments: number;
}

export interface Talent {
  id: string;
  name: string;
  role: 'Photographer' | 'Videographer' | 'Both';
  rate: number;
  zipCode?: string;
  city?: string;
  state?: string;
}

export interface TalentProfile {
  id: string;
  name: string;
  email: string;
  phone: string;
  city: string;
  state: string;
  zipCode: string;
  rating: number;
  reviewCount: number;
  projectCount: number;
  languages: string[];
  styles: string[];
  portfolioImages: string[];
  lovableChoice: boolean;
  baseRate: number;
  onboardingDate: Date;
  currentRate: number;
  status: 'Good Standing' | 'Blacklisted';
  isLoveAndPhotosChoice: boolean;
  role: 'Photographer' | 'Videographer' | 'Both';
  activeBookings: string[];
  pastBookings: string[];
}

export interface AddOn {
  name: string;
  price: number;
}

export interface Booking {
  id: string;
  clientId: string;
  clientName: string;
  eventCity: string;
  eventState: string;
  eventDate: Date;
  bookingDate: Date;
  packageType: string;
  packagePrice: number;
  addOns: number;
  addOnDetails: AddOn[];
  fees: number;
  totalAmount: number;
  amountPaid: number;
  remainingBalance: number;
  status: 'Good Standing' | 'Overdue';
  paymentTier: 'Full' | 'Deposit' | 'Monthly';
  talents: Talent[];
}

export interface ClientDetails {
  id: string;
  name: string;
  email: string;
  phone: string;
  role: 'client';
  bookings: string[];
  notes: { id: string; text: string; author: string; date: Date }[];
}

export interface UpcomingEvent {
  id: string;
  clientName: string;
  date: Date;
  location: string;
  assignedTalent: string;
}

export interface OverdueAccount {
  id: string;
  client: string;
  originalDueDate: Date;
  daysOverdue: number;
  amountDue: number;
}

export const mockFlaggedAccounts: FlaggedAccount[] = [
  {
    id: 'flag-1',
    accountName: 'Sarah & Mike Thompson',
    accountType: 'Client',
    reason: 'Payment dispute regarding final balance',
    severity: 'high',
    dateFlagged: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Client disputed $500 charge. Escalated to billing team.',
    flaggedBy: 'Admin User',
    assignedTo: 'Billing Department',
    entity: 'Billing',
  },
  {
    id: 'flag-2',
    accountName: 'Casey Brooks',
    accountType: 'Talent',
    reason: 'Missed delivery deadline',
    severity: 'medium',
    dateFlagged: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Photos delivered 3 days late. Client complained.',
    flaggedBy: 'Coordination Team',
    assignedTo: 'Admin User',
    entity: 'Coordination',
  },
  {
    id: 'flag-3',
    accountName: 'Jessica & David Brown',
    accountType: 'Client',
    reason: 'Multiple payment delays',
    severity: 'high',
    dateFlagged: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Third delayed payment. May need contract revision.',
    flaggedBy: 'Admin User',
    entity: 'Billing',
  },
  {
    id: 'flag-4',
    accountName: 'Morgan Chen',
    accountType: 'Talent',
    reason: 'Equipment damage report',
    severity: 'medium',
    dateFlagged: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000),
    status: 'Resolved',
    notes: 'Damaged client venue property. Insurance claim filed and resolved.',
    flaggedBy: 'Admin User',
    entity: 'Operations',
  },
  {
    id: 'flag-5',
    accountName: 'Alex Martinez',
    accountType: 'Talent',
    reason: 'Unprofessional behavior reported',
    severity: 'high',
    dateFlagged: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Client reported rude comments during event setup.',
    flaggedBy: 'Admin User',
    assignedTo: 'HR Department',
    entity: 'HR',
  },
  {
    id: 'flag-6',
    accountName: 'Sarah & Mike Johnson',
    accountType: 'Client',
    reason: 'Contract breach - venue restrictions',
    severity: 'medium',
    dateFlagged: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Did not inform about venue photography restrictions.',
    flaggedBy: 'Coordination Team',
    entity: 'Operations',
  },
  {
    id: 'flag-7',
    accountName: 'Taylor Reed',
    accountType: 'Talent',
    reason: 'No-show to scheduled event',
    severity: 'high',
    dateFlagged: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Failed to appear for booked wedding. Emergency replacement needed.',
    flaggedBy: 'Admin User',
    assignedTo: 'Operations Manager',
    entity: 'Operations',
  },
  {
    id: 'flag-8',
    accountName: 'Amanda & Chris Lee',
    accountType: 'Client',
    reason: 'Excessive change requests',
    severity: 'medium',
    dateFlagged: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Requested 15+ edits after final delivery. Outside scope.',
    flaggedBy: 'Coordination Team',
    entity: 'Editing',
  },
  {
    id: 'flag-9',
    accountName: 'Jordan Smith',
    accountType: 'Talent',
    reason: 'Poor quality deliverables',
    severity: 'high',
    dateFlagged: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Multiple out-of-focus shots. Client requested refund.',
    flaggedBy: 'Quality Control',
    assignedTo: 'Admin User',
    entity: 'Quality Control',
  },
  {
    id: 'flag-10',
    accountName: 'Lisa & Tom Anderson',
    accountType: 'Client',
    reason: 'Bounced payment',
    severity: 'high',
    dateFlagged: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Initial payment check bounced. Awaiting wire transfer.',
    flaggedBy: 'Billing Department',
    entity: 'Billing',
  },
  {
    id: 'flag-11',
    accountName: 'Jamie Parker',
    accountType: 'Talent',
    reason: 'Late media upload',
    severity: 'medium',
    dateFlagged: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Uploaded photos 5 days past agreed deadline.',
    flaggedBy: 'Coordination Team',
    entity: 'Coordination',
  },
  {
    id: 'flag-12',
    accountName: 'Rachel & Kevin White',
    accountType: 'Client',
    reason: 'Aggressive communication',
    severity: 'medium',
    dateFlagged: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Sent hostile emails to talent and coordination team.',
    flaggedBy: 'Admin User',
    assignedTo: 'Customer Relations',
    entity: 'Customer Relations',
  },
  {
    id: 'flag-13',
    accountName: 'Chris Thompson',
    accountType: 'Talent',
    reason: 'Copyright violation',
    severity: 'high',
    dateFlagged: new Date(Date.now() - 13 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Used client photos in personal portfolio without permission.',
    flaggedBy: 'Legal Team',
    assignedTo: 'Legal Team',
    entity: 'Legal',
  },
  {
    id: 'flag-14',
    accountName: 'Nicole & Brian Garcia',
    accountType: 'Client',
    reason: 'False damage claim',
    severity: 'medium',
    dateFlagged: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Claimed equipment damage but video evidence shows otherwise.',
    flaggedBy: 'Admin User',
    entity: 'Operations',
  },
  {
    id: 'flag-15',
    accountName: 'Sam Wilson',
    accountType: 'Talent',
    reason: 'Inappropriate social media post',
    severity: 'high',
    dateFlagged: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000),
    status: 'Open',
    notes: 'Posted client event photos on personal social media before client approval.',
    flaggedBy: 'Social Media Team',
    assignedTo: 'HR Department',
    entity: 'HR',
  },
];

export const mockZipCodeAnalytics: ZipCodeAnalytics[] = [
  { zipCode: '90210', city: 'Beverly Hills', state: 'CA', searchCount: 1247, percentage: 18.5 },
  { zipCode: '10001', city: 'New York', state: 'NY', searchCount: 1089, percentage: 16.2 },
  { zipCode: '60601', city: 'Chicago', state: 'IL', searchCount: 892, percentage: 13.3 },
  { zipCode: '33139', city: 'Miami Beach', state: 'FL', searchCount: 745, percentage: 11.1 },
  { zipCode: '94102', city: 'San Francisco', state: 'CA', searchCount: 654, percentage: 9.7 },
  { zipCode: '78701', city: 'Austin', state: 'TX', searchCount: 521, percentage: 7.8 },
  { zipCode: '98101', city: 'Seattle', state: 'WA', searchCount: 489, percentage: 7.3 },
  { zipCode: '80202', city: 'Denver', state: 'CO', searchCount: 412, percentage: 6.1 },
  { zipCode: '02108', city: 'Boston', state: 'MA', searchCount: 389, percentage: 5.8 },
  { zipCode: '30303', city: 'Atlanta', state: 'GA', searchCount: 287, percentage: 4.2 },
];

export const mockStateBookings: StateBookings[] = [
  { state: 'California', bookingCount: 342 },
  { state: 'Texas', bookingCount: 289 },
  { state: 'Florida', bookingCount: 256 },
];

export const mockOperationalData: OperationalData[] = [
  { date: new Date(Date.now() - 29 * 24 * 60 * 60 * 1000), messagesSent: 45, labelAssignments: 12 },
  { date: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000), messagesSent: 52, labelAssignments: 8 },
  { date: new Date(Date.now() - 27 * 24 * 60 * 60 * 1000), messagesSent: 38, labelAssignments: 15 },
  { date: new Date(Date.now() - 26 * 24 * 60 * 60 * 1000), messagesSent: 67, labelAssignments: 11 },
  { date: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000), messagesSent: 41, labelAssignments: 9 },
  { date: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000), messagesSent: 59, labelAssignments: 14 },
  { date: new Date(Date.now() - 23 * 24 * 60 * 60 * 1000), messagesSent: 73, labelAssignments: 18 },
  { date: new Date(Date.now() - 22 * 24 * 60 * 60 * 1000), messagesSent: 48, labelAssignments: 7 },
  { date: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000), messagesSent: 56, labelAssignments: 13 },
  { date: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000), messagesSent: 62, labelAssignments: 16 },
  { date: new Date(Date.now() - 19 * 24 * 60 * 60 * 1000), messagesSent: 44, labelAssignments: 10 },
  { date: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000), messagesSent: 71, labelAssignments: 19 },
  { date: new Date(Date.now() - 17 * 24 * 60 * 60 * 1000), messagesSent: 39, labelAssignments: 8 },
  { date: new Date(Date.now() - 16 * 24 * 60 * 60 * 1000), messagesSent: 68, labelAssignments: 15 },
  { date: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000), messagesSent: 54, labelAssignments: 12 },
];

export const mockBookings: Booking[] = [
  {
    id: '1',
    clientId: 'c1',
    clientName: 'Sarah & Mike Thompson',
    eventCity: 'Los Angeles',
    eventState: 'CA',
    eventDate: new Date('2024-06-15'),
    bookingDate: new Date('2023-12-01'),
    packageType: '8 hour photo and video',
    packagePrice: 8500,
    addOns: 1200,
    addOnDetails: [
      { name: 'Second Shooter', price: 600 },
      { name: 'Drone Coverage', price: 400 },
      { name: 'Photo Booth', price: 200 },
    ],
    fees: 350,
    totalAmount: 10050,
    amountPaid: 7500,
    remainingBalance: 2550,
    status: 'Good Standing',
    paymentTier: 'Monthly',
    talents: [
      { id: 't1', name: 'Alex Rivera', role: 'Photographer', rate: 2500 },
      { id: 't2', name: 'Jordan Lee', role: 'Videographer', rate: 3000 },
    ],
  },
  {
    id: '1b',
    clientId: 'c1',
    clientName: 'Sarah & Mike Thompson',
    eventCity: 'San Diego',
    eventState: 'CA',
    eventDate: new Date('2024-12-20'),
    bookingDate: new Date('2024-06-10'),
    packageType: '6 hour photo',
    packagePrice: 5500,
    addOns: 600,
    addOnDetails: [
      { name: 'Engagement Session', price: 500 },
      { name: 'Premium Album', price: 100 },
    ],
    fees: 200,
    totalAmount: 6300,
    amountPaid: 3000,
    remainingBalance: 3300,
    status: 'Good Standing',
    paymentTier: 'Deposit',
    talents: [
      { id: 't3', name: 'Sam Taylor', role: 'Photographer', rate: 2200 },
    ],
  },
  {
    id: '2',
    clientId: 'c2',
    clientName: 'Emily & James Wilson',
    eventCity: 'Austin',
    eventState: 'TX',
    eventDate: new Date('2024-07-20'),
    bookingDate: new Date('2024-01-10'),
    packageType: '4 hour photo',
    packagePrice: 6500,
    addOns: 800,
    addOnDetails: [
      { name: 'Engagement Session', price: 500 },
      { name: 'Premium Album', price: 300 },
    ],
    fees: 250,
    totalAmount: 7550,
    amountPaid: 5000,
    remainingBalance: 2550,
    status: 'Good Standing',
    paymentTier: 'Deposit',
    talents: [
      { id: 't3', name: 'Sam Taylor', role: 'Photographer', rate: 2200 },
    ],
  },
  {
    id: '3',
    clientId: 'c3',
    clientName: 'Jessica & David Brown',
    eventCity: 'Seattle',
    eventState: 'WA',
    eventDate: new Date('2024-08-10'),
    bookingDate: new Date('2024-02-15'),
    packageType: '6 hour photo and video',
    packagePrice: 4500,
    addOns: 500,
    addOnDetails: [
      { name: 'Same Day Edit', price: 500 },
    ],
    fees: 150,
    totalAmount: 5150,
    amountPaid: 3000,
    remainingBalance: 2150,
    status: 'Overdue',
    paymentTier: 'Monthly',
    talents: [
      { id: 't4', name: 'Morgan Chen', role: 'Photographer', rate: 1800 },
      { id: 't5', name: 'Casey Brooks', role: 'Videographer', rate: 2000 },
    ],
  },
  {
    id: '4',
    clientId: 'c4',
    clientName: 'Amanda & Chris Garcia',
    eventCity: 'Denver',
    eventState: 'CO',
    eventDate: new Date('2024-09-05'),
    bookingDate: new Date('2024-03-20'),
    packageType: '8 hour photo',
    packagePrice: 8500,
    addOns: 1500,
    addOnDetails: [
      { name: 'Drone Coverage', price: 400 },
      { name: 'Photo Booth', price: 200 },
      { name: 'Bridal Boudoir Session', price: 600 },
      { name: 'Premium Album', price: 300 },
    ],
    fees: 400,
    totalAmount: 10400,
    amountPaid: 10400,
    remainingBalance: 0,
    status: 'Good Standing',
    paymentTier: 'Full',
    talents: [
      { id: 't1', name: 'Alex Rivera', role: 'Photographer', rate: 2500 },
      { id: 't6', name: 'Drew Martinez', role: 'Videographer', rate: 2800 },
    ],
  },
  {
    id: '4b',
    clientId: 'c4',
    clientName: 'Amanda & Chris Garcia',
    eventCity: 'Boulder',
    eventState: 'CO',
    eventDate: new Date('2025-03-15'),
    bookingDate: new Date('2024-09-10'),
    packageType: '4 hour photo',
    packagePrice: 4000,
    addOns: 300,
    addOnDetails: [
      { name: 'Photo Booth', price: 200 },
      { name: 'Premium Album', price: 100 },
    ],
    fees: 150,
    totalAmount: 4450,
    amountPaid: 2000,
    remainingBalance: 2450,
    status: 'Good Standing',
    paymentTier: 'Monthly',
    talents: [
      { id: 't4', name: 'Morgan Chen', role: 'Photographer', rate: 1800 },
    ],
  },
  {
    id: '4c',
    clientId: 'c4',
    clientName: 'Amanda & Chris Garcia',
    eventCity: 'Aspen',
    eventState: 'CO',
    eventDate: new Date('2025-06-22'),
    bookingDate: new Date('2024-10-05'),
    packageType: '10 hour photo and video',
    packagePrice: 9500,
    addOns: 2200,
    addOnDetails: [
      { name: 'Second Shooter', price: 600 },
      { name: 'Drone Coverage', price: 400 },
      { name: 'Engagement Session', price: 500 },
      { name: 'Same Day Edit', price: 500 },
      { name: 'Photo Booth', price: 200 },
    ],
    fees: 450,
    totalAmount: 12150,
    amountPaid: 5000,
    remainingBalance: 7150,
    status: 'Good Standing',
    paymentTier: 'Deposit',
    talents: [
      { id: 't7', name: 'Quinn Anderson', role: 'Photographer', rate: 2600 },
      { id: 't8', name: 'Riley Johnson', role: 'Videographer', rate: 3200 },
    ],
  },
  {
    id: '5',
    clientId: 'c5',
    clientName: 'Rachel & Tom Martinez',
    eventCity: 'Miami',
    eventState: 'FL',
    eventDate: new Date('2024-09-28'),
    bookingDate: new Date('2024-04-05'),
    packageType: '10 hour photo and video',
    packagePrice: 9000,
    addOns: 2000,
    addOnDetails: [
      { name: 'Second Shooter', price: 600 },
      { name: 'Drone Coverage', price: 400 },
      { name: 'Engagement Session', price: 500 },
      { name: 'Same Day Edit', price: 500 },
    ],
    fees: 450,
    totalAmount: 11450,
    amountPaid: 6000,
    remainingBalance: 5450,
    status: 'Overdue',
    paymentTier: 'Deposit',
    talents: [
      { id: 't7', name: 'Quinn Anderson', role: 'Photographer', rate: 2600 },
      { id: 't8', name: 'Riley Johnson', role: 'Videographer', rate: 3200 },
    ],
  },
];

export const mockTalentProfiles: TalentProfile[] = [
  {
    id: 'tp1',
    name: 'BEEP',
    email: 'beep@example.com',
    phone: '(555) 777-8888',
    city: 'San Diego',
    state: 'CA',
    zipCode: '92101',
    rating: 4.5,
    reviewCount: 10,
    projectCount: 5,
    languages: ['English'],
    styles: ['Documentary', 'Artistic'],
    portfolioImages: ['https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=500&h=300&fit=crop'],
    lovableChoice: true,
    baseRate: 1700,
    onboardingDate: new Date('2024-01-01'),
    currentRate: 1700,
    status: 'Good Standing',
    isLoveAndPhotosChoice: true,
    role: 'Photographer',
    activeBookings: [],
    pastBookings: [],
  },
  {
    id: 'tp2',
    name: 'Bogey',
    email: 'bogey@example.com',
    phone: '(555) 888-9999',
    city: 'Bismarck',
    state: 'ND',
    zipCode: '58501',
    rating: 4.5,
    reviewCount: 10,
    projectCount: 5,
    languages: ['English'],
    styles: ['Documentary', 'Traditional'],
    portfolioImages: ['https://images.unsplash.com/photo-1519741497674-611481863552?w=500&h=300&fit=crop'],
    lovableChoice: false,
    baseRate: 1500,
    onboardingDate: new Date('2024-01-15'),
    currentRate: 1500,
    status: 'Good Standing',
    isLoveAndPhotosChoice: false,
    role: 'Photographer',
    activeBookings: [],
    pastBookings: [],
  },
  {
    id: 'tp3',
    name: 'Matt',
    email: 'matt@example.com',
    phone: '(555) 999-0000',
    city: 'Sacramento',
    state: 'CA',
    zipCode: '94203',
    rating: 4.5,
    reviewCount: 10,
    projectCount: 5,
    languages: ['English'],
    styles: ['Artistic', 'Traditional'],
    portfolioImages: ['https://images.unsplash.com/photo-1535478044878-3ed83d5456ef?w=500&h=300&fit=crop'],
    lovableChoice: true,
    baseRate: 1900,
    onboardingDate: new Date('2024-02-01'),
    currentRate: 1900,
    status: 'Good Standing',
    isLoveAndPhotosChoice: true,
    role: 'Photographer',
    activeBookings: [],
    pastBookings: [],
  },
  {
    id: 't1',
    name: 'Alex Rivera',
    email: 'alex@example.com',
    phone: '(555) 111-2222',
    city: 'Los Angeles',
    state: 'CA',
    zipCode: '90001',
    rating: 4.8,
    reviewCount: 24,
    projectCount: 12,
    languages: ['English', 'Spanish'],
    styles: ['Documentary', 'Artistic'],
    portfolioImages: ['https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=500&h=300&fit=crop'],
    lovableChoice: true,
    baseRate: 2500,
    onboardingDate: new Date('2023-01-15'),
    currentRate: 2500,
    status: 'Good Standing',
    isLoveAndPhotosChoice: true,
    role: 'Photographer',
    activeBookings: ['1', '4'],
    pastBookings: [],
  },
  {
    id: 't2',
    name: 'Jordan Lee',
    email: 'jordan@example.com',
    phone: '(555) 222-3333',
    city: 'Beverly Hills',
    state: 'CA',
    zipCode: '90210',
    rating: 4.9,
    reviewCount: 35,
    projectCount: 18,
    languages: ['English', 'French'],
    styles: ['Artistic', 'Traditional'],
    portfolioImages: ['https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=500&h=300&fit=crop'],
    lovableChoice: true,
    baseRate: 3000,
    onboardingDate: new Date('2023-03-20'),
    currentRate: 3000,
    status: 'Good Standing',
    isLoveAndPhotosChoice: true,
    role: 'Videographer',
    activeBookings: ['1'],
    pastBookings: [],
  },
  {
    id: 't3',
    name: 'Sam Taylor',
    email: 'sam@example.com',
    phone: '(555) 333-4444',
    city: 'San Francisco',
    state: 'CA',
    zipCode: '94102',
    rating: 4.7,
    reviewCount: 19,
    projectCount: 9,
    languages: ['English', 'Spanish'],
    styles: ['Documentary'],
    portfolioImages: ['https://images.unsplash.com/photo-1460978812857-470ed1c77af0?w=500&h=300&fit=crop'],
    lovableChoice: false,
    baseRate: 2200,
    onboardingDate: new Date('2023-05-10'),
    currentRate: 2200,
    status: 'Good Standing',
    isLoveAndPhotosChoice: false,
    role: 'Photographer',
    activeBookings: ['2'],
    pastBookings: [],
  },
  {
    id: 't4',
    name: 'Morgan Chen',
    email: 'morgan@example.com',
    phone: '(555) 444-5555',
    city: 'Austin',
    state: 'TX',
    zipCode: '78701',
    rating: 4.6,
    reviewCount: 15,
    projectCount: 7,
    languages: ['English'],
    styles: ['Traditional', 'Documentary'],
    portfolioImages: ['https://images.unsplash.com/photo-1519741497674-611481863552?w=500&h=300&fit=crop'],
    lovableChoice: true,
    baseRate: 1800,
    onboardingDate: new Date('2023-07-01'),
    currentRate: 1800,
    status: 'Good Standing',
    isLoveAndPhotosChoice: false,
    role: 'Photographer',
    activeBookings: ['3'],
    pastBookings: [],
  },
  {
    id: 't5',
    name: 'Casey Brooks',
    email: 'casey@example.com',
    phone: '(555) 555-6666',
    city: 'Dallas',
    state: 'TX',
    zipCode: '75201',
    rating: 4.4,
    reviewCount: 12,
    projectCount: 6,
    languages: ['English', 'Spanish'],
    styles: ['Artistic'],
    portfolioImages: ['https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=500&h=300&fit=crop'],
    lovableChoice: false,
    baseRate: 2000,
    onboardingDate: new Date('2023-08-15'),
    currentRate: 2000,
    status: 'Blacklisted',
    isLoveAndPhotosChoice: false,
    role: 'Videographer',
    activeBookings: [],
    pastBookings: ['3'],
  },
  {
    id: 't6',
    name: 'Drew Martinez',
    email: 'drew@example.com',
    phone: '(555) 666-7777',
    city: 'Miami',
    state: 'FL',
    zipCode: '33101',
    rating: 4.8,
    reviewCount: 28,
    projectCount: 14,
    languages: ['English'],
    styles: ['Documentary', 'Artistic'],
    portfolioImages: ['https://images.unsplash.com/photo-1535478044878-3ed83d5456ef?w=500&h=300&fit=crop'],
    lovableChoice: true,
    baseRate: 2800,
    onboardingDate: new Date('2023-09-05'),
    currentRate: 2800,
    status: 'Good Standing',
    isLoveAndPhotosChoice: true,
    role: 'Videographer',
    activeBookings: ['4'],
    pastBookings: [],
  },
  {
    id: 'tp10',
    name: 'Sophie Anderson',
    email: 'sophie@example.com',
    phone: '(555) 123-4567',
    city: 'La Jolla',
    state: 'CA',
    zipCode: '92037',
    rating: 4.7,
    reviewCount: 18,
    projectCount: 9,
    languages: ['English'],
    styles: ['Documentary', 'Artistic'],
    portfolioImages: ['https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=500&h=300&fit=crop'],
    lovableChoice: true,
    baseRate: 2100,
    onboardingDate: new Date('2024-03-01'),
    currentRate: 2100,
    status: 'Good Standing',
    isLoveAndPhotosChoice: true,
    role: 'Photographer',
    activeBookings: [],
    pastBookings: [],
  },
  {
    id: 'tp11',
    name: 'Lucas Wright',
    email: 'lucas@example.com',
    phone: '(555) 234-5678',
    city: 'Costa Mesa',
    state: 'CA',
    zipCode: '92627',
    rating: 4.6,
    reviewCount: 22,
    projectCount: 11,
    languages: ['English', 'Spanish'],
    styles: ['Traditional', 'Documentary'],
    portfolioImages: ['https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=500&h=300&fit=crop'],
    lovableChoice: false,
    baseRate: 1850,
    onboardingDate: new Date('2024-02-15'),
    currentRate: 1850,
    status: 'Good Standing',
    isLoveAndPhotosChoice: false,
    role: 'Photographer',
    activeBookings: [],
    pastBookings: [],
  },
  {
    id: 'tp12',
    name: 'Isabella Cruz',
    email: 'isabella@example.com',
    phone: '(555) 345-6789',
    city: 'Chula Vista',
    state: 'CA',
    zipCode: '91910',
    rating: 4.9,
    reviewCount: 31,
    projectCount: 16,
    languages: ['English', 'Spanish'],
    styles: ['Artistic', 'Documentary'],
    portfolioImages: ['https://images.unsplash.com/photo-1535478044878-3ed83d5456ef?w=500&h=300&fit=crop'],
    lovableChoice: true,
    baseRate: 2400,
    onboardingDate: new Date('2023-11-01'),
    currentRate: 2400,
    status: 'Good Standing',
    isLoveAndPhotosChoice: true,
    role: 'Photographer',
    activeBookings: [],
    pastBookings: [],
  },
  {
    id: 'tp13',
    name: 'Ethan Rivers',
    email: 'ethan@example.com',
    phone: '(555) 456-7890',
    city: 'Escondido',
    state: 'CA',
    zipCode: '92025',
    rating: 4.5,
    reviewCount: 14,
    projectCount: 7,
    languages: ['English'],
    styles: ['Traditional'],
    portfolioImages: ['https://images.unsplash.com/photo-1519741497674-611481863552?w=500&h=300&fit=crop'],
    lovableChoice: false,
    baseRate: 1650,
    onboardingDate: new Date('2024-04-01'),
    currentRate: 1650,
    status: 'Good Standing',
    isLoveAndPhotosChoice: false,
    role: 'Photographer',
    activeBookings: [],
    pastBookings: [],
  },
];

export const mockTalentBookingAssignments: TalentBookingAssignment[] = [
  {
    id: 'ta1',
    talentId: 't1',
    bookingId: '1',
    clientName: 'Sarah & Mike Thompson',
    eventCity: 'Los Angeles',
    eventState: 'CA',
    eventDate: new Date('2024-06-15'),
    rate: 2500,
    status: 'Talent Confirmed',
    notes: [
      { id: 'tn1', text: 'Client prefers natural light photography', author: 'Admin User', date: new Date('2024-01-20') },
    ],
    contactStatus: 'pending',
    contactDeadline: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000), // 2 days from now
    contactLogs: [],
  },
  {
    id: 'ta2',
    talentId: 't2',
    bookingId: '1',
    clientName: 'Sarah & Mike Thompson',
    eventCity: 'Los Angeles',
    eventState: 'CA',
    eventDate: new Date('2024-06-15'),
    rate: 3000,
    status: 'Talent Reached Out to Client',
    notes: [],
    firstContactTimestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    firstContactMethod: 'email',
    contactStatus: 'completed',
    contactDeadline: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000),
    contactLogs: [
      {
        id: 'cl1',
        timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
        method: 'email',
        notes: 'Sent initial introduction and event details',
        recordedBy: 'Jordan Lee'
      }
    ],
  },
  {
    id: 'ta3',
    talentId: 't3',
    bookingId: '2',
    clientName: 'Emily & James Wilson',
    eventCity: 'San Francisco',
    eventState: 'CA',
    eventDate: new Date('2024-07-20'),
    rate: 2200,
    status: 'Media Uploaded',
    notes: [
      { id: 'tn2', text: 'Delivered 500+ edited photos', author: 'Sam Taylor', date: new Date('2024-07-22') },
    ],
    firstContactTimestamp: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
    firstContactMethod: 'phone',
    contactStatus: 'completed',
    contactDeadline: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000),
    contactLogs: [
      {
        id: 'cl2',
        timestamp: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
        method: 'phone',
        notes: 'Discussed timeline and expectations',
        recordedBy: 'Sam Taylor'
      },
      {
        id: 'cl3',
        timestamp: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000),
        method: 'email',
        notes: 'Sent contract and shot list',
        recordedBy: 'Sam Taylor'
      }
    ],
  },
  {
    id: 'ta4',
    talentId: 't4',
    bookingId: '3',
    clientName: 'Jessica & David Brown',
    eventCity: 'Seattle',
    eventState: 'WA',
    eventDate: new Date('2024-08-10'),
    rate: 1800,
    status: 'Talent Confirmed',
    notes: [],
    contactStatus: 'pending',
    contactDeadline: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000), // Overdue!
    contactLogs: [],
  },
  {
    id: 'ta5',
    talentId: 't5',
    bookingId: '3',
    clientName: 'Jessica & David Brown',
    eventCity: 'Seattle',
    eventState: 'WA',
    eventDate: new Date('2024-08-10'),
    rate: 2000,
    status: 'Talent Confirmed',
    notes: [],
    contactStatus: 'pending',
    contactDeadline: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000),
    contactLogs: [],
  },
  {
    id: 'ta6',
    talentId: 't1',
    bookingId: '4',
    clientName: 'Amanda & Chris Garcia',
    eventCity: 'Denver',
    eventState: 'CO',
    eventDate: new Date('2024-09-05'),
    rate: 2500,
    status: 'Talent Reached Out to Client',
    notes: [],
    firstContactTimestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
    firstContactMethod: 'text',
    contactStatus: 'completed',
    contactDeadline: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    contactLogs: [
      {
        id: 'cl4',
        timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
        method: 'text',
        notes: 'Quick introduction via text message',
        recordedBy: 'Alex Rivera'
      }
    ],
  },
];

export const mockAnnouncements: Announcement[] = [
  {
    id: 'a1',
    message: 'Important: All talent must submit their availability for Q2 2024 by March 31st',
    createdAt: new Date('2024-03-01'),
    expiresAt: new Date('2024-03-31'),
    createdBy: 'Admin User',
  },
  {
    id: 'a2',
    message: 'New equipment available for checkout at the office. Please contact admin for details.',
    createdAt: new Date('2024-03-15'),
    expiresAt: null,
    createdBy: 'Admin User',
  },
];

export const mockClientDetails: ClientDetails[] = [
  {
    id: 'c1',
    name: 'Sarah & Mike Thompson',
    email: 'sarah@example.com',
    phone: '(555) 123-4567',
    role: 'client',
    bookings: ['1', '1b'],
    notes: [
      { id: 'n1', text: 'Prefer sunset photos at the beach', author: 'Admin User', date: new Date('2024-01-15') },
      { id: 'n2', text: 'Requested additional editing for family portraits', author: 'Alex Rivera', date: new Date('2024-02-20') },
    ],
  },
  {
    id: 'c2',
    name: 'Emily & James Wilson',
    email: 'emily@example.com',
    phone: '(555) 234-5678',
    role: 'client',
    bookings: ['2'],
    notes: [
      { id: 'n3', text: 'Venue has limited lighting, bring extra equipment', author: 'Sam Taylor', date: new Date('2024-02-10') },
    ],
  },
  {
    id: 'c3',
    name: 'Jessica & David Brown',
    email: 'jessica@example.com',
    phone: '(555) 345-6789',
    role: 'client',
    bookings: ['3'],
    notes: [
      { id: 'n4', text: 'Payment delayed, following up next week', author: 'Admin User', date: new Date('2024-03-01') },
    ],
  },
  {
    id: 'c4',
    name: 'Amanda & Chris Garcia',
    email: 'amanda@example.com',
    phone: '(555) 456-7890',
    role: 'client',
    bookings: ['4', '4b', '4c'],
    notes: [],
  },
  {
    id: 'c5',
    name: 'Rachel & Tom Martinez',
    email: 'rachel@example.com',
    phone: '(555) 567-8901',
    role: 'client',
    bookings: ['5'],
    notes: [
      { id: 'n5', text: 'Payment overdue - contacted 3 times', author: 'Admin User', date: new Date('2024-04-25') },
    ],
  },
];

export const mockUpcomingEvents: UpcomingEvent[] = [
  {
    id: 'event-1',
    clientName: 'Lisa & Mike',
    date: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000),
    location: 'Beach Resort, CA',
    assignedTalent: 'Emma Photography'
  },
  {
    id: 'event-2',
    clientName: 'Anna & David',
    date: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000),
    location: 'Garden Venue, NY',
    assignedTalent: 'Studio Moments'
  }
];

export const mockOverdueAccounts: OverdueAccount[] = [
  {
    id: 'overdue-1',
    client: 'Johnson Wedding',
    originalDueDate: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000),
    daysOverdue: 15,
    amountDue: 2500
  },
  {
    id: 'overdue-2',
    client: 'Martinez Event',
    originalDueDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    daysOverdue: 7,
    amountDue: 1200
  }
];

export interface AddOnAnalytics {
  addOnName: string;
  timesBooked: number;
  totalRevenue: number;
}

export interface PaymentOptionAnalytics {
  paymentOption: 'Pay in Full' | '$500 Deposit' | '$199 Monthly Payment Plan';
  count: number;
  percentage: number;
}

export interface BookingLeadTimeAnalytics {
  averageMonths: number;
  ranges: {
    range: string;
    count: number;
    percentage: number;
  }[];
}

export const mockAddOnAnalytics: AddOnAnalytics[] = [
  { addOnName: 'Drone Coverage', timesBooked: 47, totalRevenue: 18800 },
  { addOnName: 'Second Shooter', timesBooked: 42, totalRevenue: 25200 },
  { addOnName: 'Engagement Session', timesBooked: 38, totalRevenue: 19000 },
  { addOnName: 'Photo Booth', timesBooked: 35, totalRevenue: 7000 },
  { addOnName: 'Same Day Edit', timesBooked: 28, totalRevenue: 14000 },
  { addOnName: 'Premium Album', timesBooked: 25, totalRevenue: 7500 },
  { addOnName: 'Bridal Boudoir Session', timesBooked: 12, totalRevenue: 7200 },
];

export const mockPaymentOptionAnalytics: PaymentOptionAnalytics[] = [
  { paymentOption: '$500 Deposit', count: 98, percentage: 52.1 },
  { paymentOption: 'Pay in Full', count: 54, percentage: 28.7 },
  { paymentOption: '$199 Monthly Payment Plan', count: 36, percentage: 19.2 },
];

export const mockBookingLeadTimeAnalytics: BookingLeadTimeAnalytics = {
  averageMonths: 7.3,
  ranges: [
    { range: '0-3 months', count: 23, percentage: 12.2 },
    { range: '3-6 months', count: 45, percentage: 23.9 },
    { range: '6-9 months', count: 67, percentage: 35.6 },
    { range: '9-12 months', count: 38, percentage: 20.2 },
    { range: '12+ months', count: 15, percentage: 8.0 },
  ],
};

// Billing Dashboard Mock Data
export interface PaymentDueToday {
  id: string;
  clientName: string;
  amountDue: number;
}

export interface PaymentDueIn7Days {
  id: string;
  clientName: string;
  amountDue: number;
}

export interface OverduePayment {
  id: string;
  clientName: string;
  outstandingAmount: number;
}

export interface RecentAddOn {
  id: string;
  addOnDescription: string;
  clientName: string;
  paymentAmount: number;
}

export interface TalentPaymentAlert {
  id: string;
  clientName: string;
  eventName: string;
  amountOwed: number;
}

export const mockDueToday: PaymentDueToday[] = [
  { id: '1', clientName: 'Sarah Johnson', amountDue: 2500 },
  { id: '2', clientName: 'Michael Chen', amountDue: 1800 },
  { id: '3', clientName: 'Emily Rodriguez', amountDue: 3200 },
  { id: '4', clientName: 'Patricia Williams', amountDue: 1950 },
  { id: '5', clientName: 'Thomas Garcia', amountDue: 3750 },
  { id: '6', clientName: 'Linda Martinez', amountDue: 2200 },
  { id: '7', clientName: 'Charles Robinson', amountDue: 4100 },
  { id: '8', clientName: 'Barbara Clark', amountDue: 1600 },
];

export const mockDueIn7Days: PaymentDueIn7Days[] = [
  { id: '1', clientName: 'David Martinez', amountDue: 4500 },
  { id: '2', clientName: 'Lisa Anderson', amountDue: 2100 },
  { id: '3', clientName: 'James Wilson', amountDue: 3800 },
  { id: '4', clientName: 'Jennifer Taylor', amountDue: 2900 },
];

export const mockOverduePayments: OverduePayment[] = [
  { id: '1', clientName: 'Robert Brown', outstandingAmount: 5200 },
  { id: '2', clientName: 'Amanda Lee', outstandingAmount: 3100 },
  { id: '3', clientName: 'Christopher Davis', outstandingAmount: 4700 },
];

export const mockRecentAddOns: RecentAddOn[] = [
  { id: '1', addOnDescription: 'Extra Hours (2hr)', clientName: 'Sarah Johnson', paymentAmount: 800 },
  { id: '2', addOnDescription: 'Second Shooter', clientName: 'Michael Chen', paymentAmount: 1200 },
  { id: '3', addOnDescription: 'Extra Hours (1hr)', clientName: 'Emily Rodriguez', paymentAmount: 400 },
  { id: '4', addOnDescription: 'Drone Coverage', clientName: 'David Martinez', paymentAmount: 600 },
];

export const mockTalentPaymentAlerts: TalentPaymentAlert[] = [
  { id: '1', clientName: 'Sarah Johnson', eventName: 'Johnson-Smith Wedding', amountOwed: 2500 },
  { id: '2', clientName: 'Michael Chen', eventName: 'Chen Anniversary', amountOwed: 1800 },
  { id: '3', clientName: 'Emily Rodriguez', eventName: 'Rodriguez Corporate Event', amountOwed: 3200 },
];
